module.exports = __webpack_public_path__ + "img/zhaomu.73780a15.png";